import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Eyebrow } from "./Shared";
import { site } from "@/site.config";

const socials = [
  { label: "u-topia.com", href: site.links.utopia },
  { label: "u.center", href: site.links.ucenter },
  { label: "LinkedIn", href: site.links.linkedin },
];

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="scroll-mt-20 bg-navy py-24 lg:py-32">
      <div className="mx-auto w-full max-w-[1200px] px-6">
        <Reveal className="max-w-2xl">
          <Eyebrow>Contact</Eyebrow>
          <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl lg:text-5xl">
            If the work resonates, <span className="text-brand-orange">write.</span>
          </h2>
          <p className="mt-6 max-w-md leading-relaxed text-white/70">
            Partners, press, operators, and the simply curious: pull up a chair. Skip the DMs.
            The serious notes always get an answer.
          </p>

          <div className="mt-10 flex flex-wrap gap-x-16 gap-y-6">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/45">
                Direct
              </p>
              <a
                href={`mailto:${site.emails.primary}`}
                data-testid="contact-email-direct"
                className="mt-1 inline-block text-lg font-semibold text-white underline decoration-brand-orange decoration-2 underline-offset-4 transition-colors duration-200 hover:text-brand-orange"
              >
                {site.emails.primary}
              </a>
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/45">
                Press
              </p>
              <a
                href={`mailto:${site.emails.press}`}
                data-testid="contact-email-press"
                className="mt-1 inline-block text-lg font-semibold text-white underline decoration-brand-orange decoration-2 underline-offset-4 transition-colors duration-200 hover:text-brand-orange"
              >
                {site.emails.press}
              </a>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-7 gap-y-3 border-t border-white/10 pt-8">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`contact-social-${s.label.replace(/[^a-z]/gi, "-").toLowerCase()}`}
                className="inline-flex items-center gap-1.5 text-sm font-medium text-white/70 transition-colors duration-200 hover:text-brand-orange"
              >
                {s.label}
                <ArrowUpRight size={14} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
